module.exports = __webpack_public_path__ + "img/news8-2.c4d8df75.png";